import { addParameterCallbackToStorage } from 'app/storage/parameterCallbacks';

// Tracking used by SH
export const addParameterCallback = (fn: () => void) => {
  addParameterCallbackToStorage(fn);
};
